import { render, staticRenderFns } from "./basiccardlistingDefault.vue?vue&type=template&id=3925cfca"
import script from "./basiccardlistingDefault.vue?vue&type=script&lang=js"
export * from "./basiccardlistingDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DescCard: require('/opt/build/repo/frontend/components/cards/descCard.vue').default})
